import moment from "moment";
import React, { useState, useEffect } from "react";
import { NavLink as Link, withRouter } from "react-router-dom";
import Img from "../widgets/Img";
import { route } from "../global/route.global";
function BidsItem({ item: { title, created_at, attachments } }) {
  const [isOpen, setIsOpen] = useState(false);
  return (
    <div className="card">
      <div className="card-header" id="headingOne">
        <h5 className="mb-0">
          <div
            className="btn"
            onClick={() => setIsOpen(!isOpen)}
            style={{ textAlign: "left", width: "100%" }}
            tooltip={title}
            title={title}
          >
            <div className="d-flex justify-content-between">
              <span className="title">{title}</span>

              <span className="date">
                <span className="text-sm">Date posted: </span>{" "}
                {moment(created_at).format("MMMM D, YYYY")}
              </span>
            </div>
          </div>
        </h5>
      </div>
      <div
        id="collapseOne"
        className={`collapse ${isOpen ? "show" : ""}`}
        aria-labelledby="headingOne"
        data-parent="#accordionBids"
      >
        <div className="card-body">
          {attachments.length > 0 ? (
            <div className="d-flex flex-column container">
              <p className="">Attatchments: </p>
              <div class=" row ">
                {attachments.map((img, index) => {
                  return (
                    <div
                      className="d-flex flex-row  justify-content-betweenmb-2"
                      key={index}
                    >
                      <span>
                        <a
                          href={`${route.domain}/storage/${img}`}
                          target="_blank"
                          className="col-lg-3"
                        >
                          {img.endsWith(".pdf") ? (
                            <>
                              <i className="fa fa-file-pdf-o text-16"></i>{" "}
                              <span></span>
                            </>
                          ) : (
                            <Img
                              src={`${route.domain}/storage/${img}`}
                              alt="img"
                              width="200"
                            />
                          )}
                        </a>
                      </span>
                    </div>
                  );
                })}
              </div>
            </div>
          ) : null}
        </div>
      </div>
    </div>
  );
}

export default withRouter(BidsItem);
